(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-page"] && !Shopify.designMode) return;
  try {
    
// Optional JS for this section

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promotions-hero"] && !Shopify.designMode) return;
  try {
    
  // No JS needed

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promotions-list"] && !Shopify.designMode) return;
  try {
    
  // Optional JS for this section

  } catch(e) { console.error(e); }
})();
})();
